import { useContext, useState } from 'react'
import { v4 as uuid } from 'uuid'
import firebase from '../../firebase/compat'

import { db } from '../../firebase/config'
import { client } from '../../hooks/Client'
import { useFirestoreOrderBy } from '../../firebase/useFirestore'
import { SavedIcon } from '../../StateManagment/SavedIcon'
import { Auth } from '../../StateManagment/Auth'
import softDeleteDoc from '../../helpers/softDeleteDoc'

import Table from '../../components/common/table/Table'
import DeleteModal from '../../components/common/DeleteModal'
import PageHeader from '../../components/layout/PageHeader'
import ReadOnlyGuard from '../../components/common/ReadOnlyGuard'
import MaterialsModal from './MaterialsModal'
import { MATERIALS_COLUMNS, materialRowCells } from './materialsTable'
import materialWritePayload from '../../helpers/materialsHelpers/materialWritePayload'
import { materialSearchText } from '../../helpers/materialsHelpers/materialDisplayName'

const Materials = () => {
    const [, setSaved] = useContext(SavedIcon)
    const [auth] = useContext(Auth)

    const [editorOpen, setEditorOpen] = useState(false)
    const [selectedMaterial, setSelectedMaterial] = useState(null)
    const [deleteModal, setDeleteModal] = useState(false)
    const [deleteDocid, setDeleteDocid] = useState('')
    const [deleteName, setDeleteName] = useState('')

    const materials = useFirestoreOrderBy('Materials', 'Position', 'asc')
    const items = Array.isArray(materials) ? materials : []

    const openAdd = () => {
        setSelectedMaterial(null)
        setEditorOpen(true)
    }

    const openEdit = (material) => {
        setSelectedMaterial(material)
        setEditorOpen(true)
    }

    const saveMaterial = async (form) => {
        // Both branches write the same field list — see materialWritePayload
        // for why that list is no longer spelled out here.
        const payload = materialWritePayload(form)

        if (selectedMaterial) {
            await db.collection('Materials').doc(selectedMaterial.docid).update({
                ...payload,
                Timestamp: firebase.firestore.FieldValue.serverTimestamp(),
            })
        } else {
            await db.collection('Materials').add({
                ID: uuid(),
                CompagnyID: client,
                Compagny: client,
                Position: items.length + 1,
                Timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                ...payload,
            })
        }

        setSaved('flex')
        setEditorOpen(false)
        setSelectedMaterial(null)
    }

    const deleteModalHandler = (e) => {
        e.stopPropagation()
        setDeleteDocid(e.currentTarget.dataset.docid)
        setDeleteName(e.currentTarget.dataset.deletename)
        setDeleteModal(true)
    }

    // Zacht verwijderd (ADR-008), niet hard: regels bij bewoners wijzen naar dit
    // materiaal en houden zo hun naam, eenheid en prijs, en blijven meetellen in
    // de CO2 en de besparing. Uit de keuzelijst is het wel weg (inbox #284).
    const deleteMaterial = async () => {
        await softDeleteDoc({ collection: 'Materials', docid: deleteDocid, authId: auth?.ID, title: deleteName })
        setSaved('flex')
    }

    return (
        <div className='main'>
            <div className='main-container'>
                <PageHeader
                    heading={'Materialen'}
                    description={'Het overzicht van alle materialen en coachadviezen'}
                    AI={false}
                />
                <div className='table-container'>
                    <ReadOnlyGuard edit="housevisits.edit">
                        {(canEdit) => (
                        <Table
                            columns={MATERIALS_COLUMNS}
                            items={items}
                            getItemKey={(m) => m.ID}
                            renderRow={(m) => (
                                <>{materialRowCells(m, { canEdit, openEdit, deleteModalHandler })}</>
                            )}
                            searchAccessor={materialSearchText}
                            searchPlaceholder='Zoeken op materiaal of advies'
                            emptyMessage='Nog geen materialen of coachadviezen toegevoegd.'
                            addRow={canEdit ? {
                                toolTipContent: 'Materiaal of advies toevoegen',
                                onClick: openAdd,
                            } : undefined}
                        />
                        )}
                    </ReadOnlyGuard>
                </div>
            </div>

            <MaterialsModal
                modalOpen={editorOpen}
                setModalOpen={setEditorOpen}
                material={selectedMaterial}
                onSave={saveMaterial}
            />

            <DeleteModal
                deleteModal={deleteModal}
                setDeleteModal={setDeleteModal}
                deleteItem={deleteMaterial}
                deleteName={deleteName}
                softDelete
            />
        </div>
    )
}

export default Materials
